<div class="ion-text-center ion-padding-vertical full-height">
    <div class="ion-margin-vertical">
        <ion-spinner></ion-spinner>
    </div>
</div>
